import React, { useMemo } from 'react';
import PlatformTitle from '../PlatformTitle';
import ProgressContext from '@/pages/opinion/components/ProgressContext';
import { useIntl } from 'umi';
import { platformTitleMap } from '../../constants';
import { NO_DATE } from '@/pages/opinion/constants';
import { formatSimpleTimeFunc } from '@/pages/opinion/utils/time';
import CardCommon from '@/pages/opinion/components/CardCommon';

export default function VerticalScoreBox({
  title,
  data,
  channel = 'meta_score',
  dataKeys = ['meta_score', 'user_score'],
  className,
  showHeader = true,
  hasEmptyImg = false,
  hasEmptyTitle = false,
  size = 16,
}: any) {
  const { formatMessage } = useIntl();

  const [list, time, noData] = useMemo(() => {
    const { has_date_time, list } = data || {};

    const noData = Object.keys(list || {}).length === 0;
    const renderList = dataKeys.map((key: string) => {
      const item = list?.[key] || {};
      return {
        review: item.review || 0,
        score: item.score || 0,
        key,
      };
    });

    return [renderList, has_date_time, noData];
  }, [data]);

  return (
    <div className={`vertical-game-store-wrapper ${className}`}>
      {showHeader && (
        <PlatformTitle
          className="channel-title-info"
          title={title}
          channelName={channel}
          iconTextMargin={6}
          size={size}
        >
          <p className="right-text">
            {time
              ? `${formatMessage({ id: 'Up to' })} ${formatSimpleTimeFunc(
                  time,
                )}`
              : null}
          </p>
        </PlatformTitle>
      )}
      <CardCommon
        contentCard
        empty={noData}
        hasEmptyImg={hasEmptyImg}
        hasEmptyTitle={hasEmptyTitle}
        emptyHeight={160}
      >
        <div className="progress-context-box">
          {list?.map(({ review, score, key }: any) => (
            <ProgressContext
              key={key}
              percent={key === 'user_score' ? score * 10 : score}
              circle
              sentiment
              strokeWidth={10}
              sizeWidth={120}
              text={score + (key === 'critics_recommend' ? '%' : '')}
              title={formatMessage({
                id: platformTitleMap[key] || NO_DATE.EMPTY,
              })}
              reviewNum={review}
            />
          ))}
        </div>
      </CardCommon>
    </div>
  );
}
